<template>
    <div
        :class="['detail-item', { 'has-image' : hasImage }]"
        @click="$emit('click', stockListing )"
    >
        <span class="registration small" style="min-width: 60px;">
            {{ vrm(stockListing.vehicle) }}
        </span>

    <div class="truncate">
            <span class="chip-item-title">{{ title }}</span>
        </div>

        <div
            v-if="hasImage"
            class="item-image"
            :style="{backgroundImage: 'url(' + thumbnailUrl(imageUrl) + ')' }"
        ></div>
    </div>
</template>

<script>
import {vrm} from "../filters/vehicle/vrm";

export default {
    props: {
        stockListing: {
            required: true,
            type: Object
        }
    },
    computed: {
        title() {
            // Legacy API
            if (this.stockListing.title) {
                return this.stockListing.title
            }

            // New API
            if (this.stockListing.meta && this.stockListing.meta.title) {
                return this.stockListing.meta.title
            }

            return this.stockListing.vehicle.title
        },
        hasImage() {
            return !!this.stockListing && !!this.stockListing.image
        },
        imageUrl() {
            // Legacy API
            if (this.stockListing.image.preview_url) {
                return this.stockListing.image.preview_url
            }

            return this.stockListing.image.url
        }
    },
    methods: {
        vrm,
        thumbnailUrl(url) {
            return url.replace('_dimensions_', 'h150')
        },
    }
}
</script>

<style lang="scss" scoped>
    .detail-item {
        padding: .5rem 1rem .5rem .75rem;
        //background: #f0f0f0;
        background: linear-gradient(310deg, #f0f0f0, #f9f9f9);
        border-radius: 5px;
        display: inline-flex;
        max-width: 100%;
        margin-right: 1rem;
        position: relative;
        overflow: hidden;
        align-items: center;
        cursor: pointer;
        border: 1px solid #f0f0f0;

        &.has-image {
            padding-left: 75px;
        }

        .chip-item-title {
            font-weight: 500;
        }

        &.missing-item-count {
            min-width: auto;
            white-space: nowrap;
        }

        &:hover {
            background: #ddd;
        }

        .item-image {
            width: 65px;
            height: 100%;
            position: absolute;
            left: 0;
            top:0;
            background-position: center;
            background-size: cover;
        }

        .truncate { max-width: 100%; }

        .registration {
            font-size: 10px;
            line-height: normal;
            vertical-align: middle;
            margin: 0;
            width: 65px;
            height: 20px;
            padding-left: 3px;
            padding-right: 3px;
        }

        span {
            vertical-align: middle;
            margin-left: .5rem;
            margin-right: 0rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex-grow:1;
            font-size: 14px;
            line-height: 25px;
        }
    }
</style>